import styled from '@emotion/styled';
import Flex from '../../shared/layouts/Flex';

const CategoryHeader = styled(Flex)(({ gap }) => ({
  '> *': {
    flex: '1 1 50%',
  },
  '>:first-of-type:not(button)': {
    marginRight: gap || '12.5%',
  },
}));

CategoryHeader.defaultProps = {
  fontScale: 'm',
  fontWeight: 'bold',
};

export default CategoryHeader;
